import { Link } from 'react-router-dom';

interface FooterProps {
  /** Opens the Contact Us modal — owned at AppShell level. */
  onContactOpen: () => void;
}

export const Footer = ({ onContactOpen }: FooterProps) => {
  return (
    <footer>
      <div className="border-t border-black/10 bg-[#f5f6f2] px-8 py-10 font-['Inter',sans-serif] leading-[normal]">
        <div className="mx-auto flex max-w-[1180px] flex-wrap items-center justify-between gap-4">
          <div className="flex flex-col items-start gap-3">
            <Link to="/" aria-label="QuantumHire — home" className="flex items-center">
              <img
                src="/logos/quantumhire-logo-poppins.png"
                alt="QuantumHire"
                className="block h-auto w-[150px] origin-left scale-[1.125]"
              />
            </Link>

            {/* <Link
              to="/startups"
              className="mt-1 w-full border-t border-black/10 pt-3 text-[13px] text-[#3a3c35] transition-colors hover:text-[#0b5c22]"
            >
              QuantumHire for Startups
            </Link>

            <Link
              to="/exfounders"
              className="w-full text-[13px] text-[#3a3c35] transition-colors hover:text-[#0b5c22]"
            >
              Roles for Ex-Founders
            </Link>
            
            <Link
              to="/career-restart"
              className="w-full text-[13px] text-[#3a3c35] transition-colors hover:text-[#0b5c22]"
            >
              Restart for Women
            </Link> */}
            <Link
              to="/screeners"
              className="w-full border-t border-black/10 pt-3 text-[13px] text-[#3a3c35] transition-colors hover:text-[#0b5c22]"
            >
              For screeners
            </Link>
          </div>

          <span className="font-['JetBrains_Mono',monospace] text-xs tracking-[.02em] text-[#6b6f68]">
            Recruitment, run at the speed of intelligence — quantumhire.ai
          </span>
        </div>
      </div>

      <div className="border-t border-black/10 bg-[#ebece5] px-8 py-6 font-['JetBrains_Mono',monospace] text-[10.5px] font-normal text-[#6b6f68]">
        <div className="mx-auto flex max-w-[1180px] flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 QUANTUMHIRE. ALL RIGHTS RESERVED.</p>
          <div className="flex items-center gap-8">
            <Link to="/privacy" className="transition-colors hover:text-[#0b5c22]">
              Privacy
            </Link>
            <button
              type="button"
              onClick={onContactOpen}
              className="tracking-[.03em] transition-colors hover:text-[#0b5c22]"
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
